import { PayloadAction } from "@reduxjs/toolkit";
import { call, put, all, takeLatest } from "redux-saga/effects";
import {
  DataResponse,
  ListDataResponse,
  MockAxiosResponse,
} from "utils/commonModels";
import {
  AreaDataModel,
  IAreaRequest,
  ICategoryRequest,
  CategoryDataModel,
  IDistrictData,
} from "../models";
import { mockupApis } from "../mockupApis";
import { homepageActions } from "./homepageSlice";
import { AxiosResponse } from "axios";
import { homepageApi } from "../homepageApi";

function* fetchAreaList(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse<DataResponse<AreaDataModel[]>> = yield call(
      // homepageApi.getArea,
      mockupApis.getArea,
      action.payload
    );
    if (response && response.status === 200) {
      yield put(homepageActions.getAreasSuccess(response.data.body.data));
    } else {
      console.log("Failed to fetch area list", response.statusText);
      yield put(homepageActions.getDataFailed(response.statusText));
    }
  } catch (error: any) {
    console.log("Failed to fetch area list", error);
    yield put(homepageActions.getDataFailed(error));
  }
}

function* fetchDistricList(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse<DataResponse<IDistrictData[]>> = yield call(
      homepageApi.getDistrict,
      // mockupApis.getDistricts,
      action.payload
    );    
    if (response && (response.status === 200 || response.status === 201)) {
      yield put(homepageActions.getDistrictsSuccess(response.data.body.data));
    } else {
      console.log("Failed to fetch district list", response.statusText);
      yield put(homepageActions.getDataFailed(response.statusText));
    }
  } catch (error: any) {
    console.log("Failed to fetch district list", error);
    yield put(homepageActions.getDataFailed(error));
  }
}

function* fetchKeywordList(action: PayloadAction<string>) {
  try {
    const response: MockAxiosResponse<string[]> = yield call(
      mockupApis.getKeyword,
      action.payload
    );
    if (response && response.status === 200) {
      yield put(homepageActions.getKeywordsSuccess(response));
    } else {
      console.log("Failed to fetch keyword list", response.statusText);
      yield put(homepageActions.getDataFailed(response.statusText));
    }
  } catch (error: any) {
    console.log("Failed to fetch keyword list", error);
    yield put(homepageActions.getDataFailed(error));
  }
}

function* fetchFoodGenreList(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse<DataResponse<CategoryDataModel[]>> = yield call(
      homepageApi.getGenres,
      action.payload
    );
    if (response && (response.status === 200 || response.status === 201)) {
      if (response.data.statusCode === 201) {
        yield put(
          homepageActions.getFoodGenresSuccess(response.data.body.data)
        );
      } else {
        yield put(homepageActions.getFoodGenresSuccess([]));
      }
    } else {
      console.log("Failed to fetch food genre list", response.statusText);
      yield put(homepageActions.getFoodGenresFail(response.statusText));
    }
  } catch (error: any) {
    console.log("Failed to fetch food genre list", error);
    yield put(homepageActions.getFoodGenresFail(error));
  }
}

function* fetchScrenarioList(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse<DataResponse<CategoryDataModel[]>> =
      yield call(homepageApi.getScenes, action.payload);
    if (
      response &&
      (response.status === 200 || response.data.statusCode === 200)
    ) {
      if (response.data.statusCode === 201) {
        yield put(homepageActions.getScrenarioSuccess(response.data.body.data));
      } else {
        yield put(homepageActions.getScrenarioSuccess([]));
      }
    } else {
      console.log("Failed to fetch scenario list", response.statusText);
      yield put(homepageActions.getScenarioFail(response.statusText));
    }
  } catch (error: any) {
    console.log("Failed to fetch scenario list", error);
    yield put(homepageActions.getScenarioFail(error));
  }
}

function* fetchConditionList(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse<DataResponse<CategoryDataModel[]>> =
      yield call(homepageApi.getConditions, action.payload);
    if (
      response &&
      (response.status === 200 || response.data.statusCode === 200)
    ) {
      if (response.data.statusCode === 201) {
        yield put(
          homepageActions.getConditionsSuccess(response.data.body.data)
        );
      } else {
        yield put(homepageActions.getConditionsSuccess([]));
      }
    } else {
      console.log("Failed to fetch condition list", response.statusText);
      yield put(homepageActions.getConditionFail(response.statusText));
    }
  } catch (error: any) {
    console.log("Failed to fetch condition list", error);
    yield put(homepageActions.getConditionFail(error));
  }
}

export function* homepageSaga() {
  yield all([
    takeLatest(homepageActions.getAreas.type, fetchAreaList),
    takeLatest(homepageActions.getDistricts.type, fetchDistricList),
    takeLatest(homepageActions.getKeywords.type, fetchKeywordList),
    takeLatest(homepageActions.getFoodGenres.type, fetchFoodGenreList),
    takeLatest(homepageActions.getScrenario.type, fetchScrenarioList),
    takeLatest(homepageActions.getConditions.type, fetchConditionList),
  ]);
}
